import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  CssBaseline,
  Grid,
} from "@mui/material";

import Header from "../../../../common/Header";
import Sidebar from "../../../../common/Sidebar";
import {
  drawerWidth,
  mainLayoutStyles,
  routes,
  showNotification,
} from "../../../../constants";
import {
  QuickTalesContributorsTable,
  FilterSectionContributors,
  AddContributorsTable,
  SearchBar,
} from "../../components/components";
import { useNavigate } from "react-router-dom";
import { useContributorsContext } from "../../../../providers/OrganizationAdmin/ContributorsProvider";
import {
  contributorsSearch,
  deleteContributorInvite,
  getFilterContributors,
  updateContributor,
  updateContributorInvite,
} from "../../hooks/ContributorsHook";
import { useAuth } from "../../../../hooks";
import { Toast } from "../../../../common/alert";
import ConfirmationModal from "../../../../common/ConfirmationModal";
import FilterModalComponent from "../../../../common/FilterModalComponent";
import { getSingleUser } from "../../../OrganizationQuickTales/hooks/QuickTalesHooks";
import { useCommonContext } from "../../../../providers/CommonProvider";
import { useOrganizationContext } from "../../../../providers/OrganizationAdmin/OrganizationProvider";

const QuickTalesContributorsContainer = () => {
  const { allContributors, setLoading, handleGetAllContributors, loading } =
    useContributorsContext();
  const { currentUser, organizationId } = useAuth();
  const { handleOnSendNotification } = useCommonContext();
  const { currentOrganization, handleGetOrganization } =
    useOrganizationContext();

  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);
  const [addContributor, setAddContributor] = useState(false);
  const [contributorsData, setContributorsData] = useState([]);

  useEffect(() => {
    handleGetOrganization();
  }, []);

  useEffect(() => {
    handleGetAllContributors();
  }, []);

  useEffect(() => {
    setContributorsData(allContributors);
  }, [allContributors]);

  // console.log("contributors:", allContributors);

  const handleFilterModalOpen = () => {
    setFilterModal(true);
  };
  const handleFilterModalClose = () => {
    setFilterModal(false);
  };
  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };
  const handleDeleteModalClose = () => {
    setDeleteModal(false);
  };
  const handleSearchContributors = async (e) => {
    try {
      let value = e.target.value;
      if (value.length >= 1) {
        let contributorsSearchTemp = await contributorsSearch(
          allContributors,
          value
        );
        console.log("searched:", contributorsSearchTemp);
        setContributorsData(contributorsSearchTemp);
      } else {
        setContributorsData(allContributors);
      }
    } catch (error) {
      console.log("error searching contributors:", error.message);
    }
  };

  const handleFilterContributors = async () => {
    setSelected([]);
    if (filterOptions.length > 0) {
    let temp = await getFilterContributors(
      filterOptions,
      setLoading,
      handleFilterModalClose,
      organizationId ? organizationId : currentUser.organization
    );
    console.log("filter data:", temp);
    setContributorsData([...temp]);
  }
    if (filterOptions.length === 0) {
      setContributorsData(allContributors);
    }
  };

  console.log("selected row:", selected)

  const handleUpdateContributorStatus = async (status) => {
    try {
      setLoading(true);
      if (selected.length) {
        const selectedUsersDetails = allContributors
          .filter((user) => selected.includes(user.id))
          .map((userRecord) => userRecord);

        for (const userData of selectedUsersDetails) {
          let userResponse = await getSingleUser(userData?.userId);
          // console.log("user data::", userResponse.data());
          // let orgTemp = [
          //   organizationId ? organizationId : currentUser.organization,
          // ];
          if (
            userResponse?.data() &&
            userResponse?.data()?.organizations &&
            userResponse
              ?.data()
              ?.organizations?.includes(
                organizationId ?? currentUser.organization
              )
          ) {
            if (status !== "accepted") {
              let orgTemp = [...(userResponse?.data()?.organizations ?? [])];
              const updatedOrganization = orgTemp.filter((id) =>
                id !== organizationId
                  ? organizationId
                  : currentUser.organization
              );
              let dataTemp = {
                organizations: updatedOrganization,
                updatedBy: currentUser.id,
                updatedAt: new Date(),
              };
              await updateContributor(userData?.userId, dataTemp);
            }
            // showNotification(
            //   "This User is already a contributor to this Organization."
            // );
          } else {
            let dataTemp = {
              organizations: [
                ...(userResponse?.data()?.organizations ?? []),
                organizationId ?? currentUser.organization,
              ],
              updatedBy: currentUser.id,
              updatedAt: new Date(),
            };

            if (status === "accepted") {
              await updateContributor(userData?.userId, dataTemp);
              await handleOnSendNotification({
                userId: userData?.id,
                userData: userData,
                data: {
                  fromUserId: currentUser?.id,
                  // fromUserId: fromUser?.userId,
                  toUserId: userData?.id,
                  title: `You are added as a contributor`,
                  // title: `You are added as a contributor to ${organization.title}`,
                  subTitle: `You are approved as a Contributor for ${currentOrganization?.name}, You can now submit QTs to ${currentOrganization?.name} from any QuickTale edit page.`,
                  // subTitle: `You have been added as a contributor to ${currentOrganization?.name}, you can now submit QTs to ${currentOrganization?.name}`,
                  type: "invites",
                  subType: "contributor_request_accepted",
                  docRef: "organizations",
                  //organization id to which the user is added as contributor
                  docRefId: organizationId
                    ? organizationId
                    : currentUser.organization ?? "",
                },
              });
            }
            //  else {
            //   let orgTemp = [...(userResponse?.data()?.organizations ?? [])];
            //   const updatedOrganization = orgTemp.filter((id) =>
            //     id !== organizationId
            //       ? organizationId
            //       : currentUser.organization
            //   );
            //   let dataTemp = {
            //     organizations: updatedOrganization,
            //     updatedBy: currentUser.id,
            //     updatedAt: new Date(),
            //   };
            //   await updateContributor(userData?.userId, dataTemp);
            // }
          }
          let statusUpdateData = {
            updatedAt: new Date(),
            status: status,
            updatedBy: currentUser?.id,
          };
          await updateContributorInvite(statusUpdateData, userData?.id);
        }
      }
      await handleGetAllContributors();
      setSelected([]);
      showNotification("Contributor status updated successfully.");
      // let dataTemp = {
      //   status: status,
      //   updatedAt: new Date(),
      // };
      // let orgTemp = [
      //   organizationId ? organizationId : currentUser.organization,
      // ];

      // console.log("orgTemp:", orgTemp);
      // let orgDataTemp = {
      //   organization: userData.organization
      //     ? [
      //         ...userData.organization,
      //         organizationId ? organizationId : currentUser.organization,
      //       ]
      //     : orgTemp,
      // };
      // selected.forEach(async (item) => {
      //   let responseTemp = await updateContributor(item, dataTemp);
      //   console.log("update admin response:", responseTemp);
      // });
      // Toast("success", "admin status updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating contributor status", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteContributor = async () => {
    try {
      setLoading(true);
      if (selected.length) {
        const selectedUsersDetails = allContributors
          .filter((user) => selected.includes(user.id))
          .map((userRecord) => userRecord);

        for (const userData of selectedUsersDetails) {
          let userResponse = await getSingleUser(userData?.userId);
          let orgTemp = [...(userResponse?.data()?.organizations ?? [])];
          const updatedOrganization = orgTemp.filter((id) =>
            id !== organizationId ? organizationId : currentUser.organization
          );
          let dataTemp = {
            organizations: updatedOrganization,
            updatedBy: currentUser.id,
            updatedAt: new Date(),
          };
          let responseTemp = await updateContributor(userData.userId, dataTemp);
          let deleteResponseTemp = await deleteContributorInvite(userData.id);
        }
      }
      await handleGetAllContributors();
      setSelected([]);

      handleDeleteModalClose();

      showNotification("Contributor deleted successfully.");
      // Toast("success", "Contributor Deleted successfully.");
    } catch (error) {
      console.log("error deleting contributor:", error.message);
    } finally {
      setLoading(false);
      handleDeleteModalClose();
    }
  };

  const handleDeleteChip = (filterItem) => {
    setFilterOptions((prevOptions) => prevOptions.filter((item) => item !== filterItem));
  };

  
  useEffect(() => {
    handleFilterContributors();
  }, [filterOptions]);

  const resetFilter = async () => {
    setFilterOptions([]);
    setContributorsData(allContributors);
    setSelected([]);
  };

  const handlePageLoadingClose = () => {
    setLoading(false);
  };

  // console.log("Sring from url", addContributor);

  return (
    <Box sx={{ display: "flex", width: "100%", paddingRight: 4 }}>
      <CssBaseline />
      <Header
        mainTitle={"Contributors"}
        bgColor="#fff"
      //  buttonText={"Add Contributor"}
      //  handleSubmit={() => {
      //    navigate(routes.addContributor);
      //  }}
      />
      <Sidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        {addContributor ? (
          <>
            <AddContributorsTable
              selected={selected}
              setSelected={setSelected}
            />
          </>
        ) : (
          <Grid container direction={"column"}>
            <FilterSectionContributors
              handleFilterModalOpen={handleFilterModalOpen}
              filterOptions={filterOptions}
              handleDeleteChip={handleDeleteChip}
            />
            <SearchBar
              selected={selected}
              setSelected={setSelected}
              handleSearch={handleSearchContributors}
              handleUpdateContributorStatus={handleUpdateContributorStatus}
              handleDeleteContributor={handleDeleteModalOpen}
            />
            <QuickTalesContributorsTable
              selected={selected}
              setSelected={setSelected}
              contributorsData={contributorsData}
            />
          </Grid>
        )}
      </Grid>
      <ConfirmationModal
        modalOpen={deleteModal}
        handleClose={handleDeleteModalClose}
        handleClick={handleDeleteContributor}
        loading={loading}
        title={"Are you sure to Deactivate the selected Contributor(s)?"}
      />
      {/* <FilterModalContributors
        modalOpen={filterModal}
        handleClose={handleFilterModalClose}
        filterOptions={filterOptions}
        setFilterOptions={setFilterOptions}
        handleFilterContributors={handleFilterContributors}
      /> */}
      <FilterModalComponent
        modalOpen={filterModal}
        handleClose={handleFilterModalClose}
        resetFilter={resetFilter}
        handleFilter={handleFilterContributors}
        data={[
          {
            mainOptions: filterOptions,
            setMainOptions: setFilterOptions,
            type: "text",
            title: "Status",
            currentOptions: [
              { label: "All", selected: true },
              { label: "accepted", selected: false },
              { label: "pending", selected: false },
              { label: "declined", selected: false },
              { label: "requested", selected: false },
            ],
          },
        ]}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handlePageLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default QuickTalesContributorsContainer;
